<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.bulletins', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div v-for="bulletin in bulletins.data" :key="bulletin.uuid" class="mt-5">
            <AppWell>
                <AppCard>
                    <div class="font-semibold">
                        {{ bulletin.title }}
                    </div>
                    <div v-if="bulletin.image_path" class="mt-2">
                        <img :src="bulletin.image_path" alt="cover" />
                    </div>
                    <p v-html="bulletin.body" class="prose prose-sm" />
                    <hr class="my-1" />
                    <LinkList :links="bulletin.links" />
                </AppCard>

                <AppCard v-if="bulletin.attachments.length" class="mt-5">
                    <AttachmentsList :attachments="bulletin.attachments" />
                </AppCard>
                <div v-if="meta.info.school_signature">
                    <img :src="meta.info.school_signature" class="mt-3" alt="signature" />
                </div>
            </AppWell>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import LinkList from '@/components/LinkList.vue';
import AppWell from '@/Shared/AppWell.vue';
import AppCard from '@/Shared/AppCard.vue';
import AttachmentsList from '@/components/AttachmentsList.vue';

export default {
    components: {
        PanelPage,
        LinkList,
        AppWell,
        AppCard,
        AttachmentsList,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'bulletins'],
};
</script>
